<template>
  <div class="options">
    <div class="backdrop"></div>
    <div class="content">
      <!--      <div class="close" @click="cancel">×</div>-->
      <NewTranslation class="title" path="registrationFormConfirm.title"></NewTranslation>
      <NewTranslation class="description" path="registrationFormConfirm.description"></NewTranslation>
      <div class="form">
        <Button
          class="button"
          color="green"
          @click.native="confirm"
          path="registrationFormConfirm.confirm.button"
        ></Button>
        <!--        <Button class="button" @click.native="cancel" path="registrationFormConfirm.back.button"></Button>-->
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation';
import i18next from 'i18next';
import { mapMutations } from 'vuex';

export default {
  components: {
    NewTranslation,
    Button,
  },
  props: ['overlaydata'],
  methods: {
    cancel() {
      this.$store.commit('openOverlay', '');
      this.resetBookingData();
      this.$router.push({ name: this.$namedRoutes.transactionOverview });
    },
    confirm() {
      this.$store.commit('openOverlay', '');
    },
    resetBookingData() {
      this.setCurrentBooking(null);
      this.setCurrentPriceProjection(null);
      this.setCurrentOrderId(null);
    },
    translate(path, params) {
      return i18next.t(path, params);
    },
    ...mapMutations('booking', ['setCurrentBooking', 'setCurrentPriceProjection', 'setCurrentOrderId']),
  },
};
</script>

<style lang="sass" scoped>
.options
	width: 100%
	height: 100vh
	display: flex
	flex-direction: column
	align-items: center
	justify-content: center
	position: fixed
	max-width: 480px
	margin: 0 auto
	right: 0
	top: 0
	left: 0
	z-index: 9
.backdrop
	background-color: rgba(0, 0, 0, .8)
	width: 100%
	height: 100vh
	position: absolute
	z-index: 6
.close
	position: absolute
	right: 20px
	top: 20px
	background-color: #fff
	z-index: 9
	color: #1DB2D1
	border: 1px solid #1DB2D1
	width: 20px
	height: 20px
	display: flex
	justify-content: center
	align-items: center
	border-radius: 20px
.content
	z-index: 7
	background-color: #fff
	border-radius: 10px
	padding: 20px
	margin: 20px
	position: relative
.title
	display: block
	font-size: 20px
	color: #1DB2D1
	text-align: center
.description
	display: block
	text-align: center
	color: #454F63
	margin-top: 20px
.form
	margin-top: 20px
	.field
		display: flex
		flex-direction: column
		& + .field
			margin-top: 20px
		input,
		select
			color: #454F63
			border-radius: 3px
			border: 1px solid #B3BAC8
			padding: 15px 15px 15px 45px
			margin-top: 5px
			background-color: #fff
			font-size: 1rem
			font-family: inherit
			width: 100%
		&-input
			position: relative
			svg
				position: absolute
				bottom: 0
				top: 5px
				left: 20px
				width: 15px
				margin-top: auto
				margin-bottom: auto
			input[type="date"]
				min-height: 50px
				-webkit-appearance: textfield
				appearance: textfield
				width: 100%
	.button
		margin-top: 20px
</style>
